document.addEventListener('DOMContentLoaded', () => {

  const accordions = document.querySelectorAll('.nxa-block-accordion');

  accordions.forEach(accordion => {

    const visibilityToggle = accordion.querySelector('.visibility-toggle');
    if (visibilityToggle) {
      let animating = false;
      const resetItemAndRemoveHandler = (item, handler) => {
        item.style.maxHeight = '';
        item.style.opacity = '';
        item.style.overflow = '';
        item.style.transition = '';
        item.style.pointerEvents = '';
        item.removeEventListener('transitionend', handler);
      };
      visibilityToggle.addEventListener('click', () => {
        if (animating) return;
        const hiddenItems = Array.from(accordion.querySelectorAll('.item')).filter(item => {
          return window.getComputedStyle(item).display === 'none';
        });
        if (hiddenItems.length > 0) {
          // Einblenden
          visibilityToggle.setAttribute('aria-expanded', 'true');
          visibilityToggle.querySelector('svg').style.transform = 'scaleY(-1)';
          visibilityToggle.querySelector('.show-more').style.display = 'none';
          visibilityToggle.querySelector('.show-less').style.display = '';
          hiddenItems.forEach((item, index) => {
            animating = true;
            setTimeout(() => {
              item.style.display = '';
              item.style.maxHeight = '0';
              item.style.opacity = '0';
              item.style.overflow = 'hidden';
              item.style.transition = 'max-height .3s ease, opacity .6s ease';
              item.style.pointerEvents = 'none';
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  item.style.maxHeight = `${item.scrollHeight}px`;
                  item.style.opacity = '1';
                  const handler = (e) => {
                    if (e.propertyName !== 'opacity') return;
                    resetItemAndRemoveHandler(item, handler);
                    if (index === hiddenItems.length - 1) {
                      animating = false;
                    }
                  };
                  item.addEventListener('transitionend', handler);
                });
              });
            }, index * 100);
          });
        } else {
          // Ausblenden
          visibilityToggle.setAttribute('aria-expanded', 'false');
          visibilityToggle.querySelector('svg').style.transform = '';
          visibilityToggle.querySelector('.show-more').style.display = '';
          visibilityToggle.querySelector('.show-less').style.display = 'none';
          const itemsToHide = Array.from(accordion.querySelectorAll('.item')).slice(4).reverse();
          itemsToHide.forEach((item, index) => {
            animating = true;
            setTimeout(() => {
              item.style.maxHeight = `${item.scrollHeight}px`;
              item.style.opacity = '1';
              item.style.overflow = 'hidden';
              item.style.transition = 'max-height .3s ease .3s, opacity .3s ease';
              item.style.pointerEvents = 'none';
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  item.style.maxHeight = '0';
                  item.style.opacity = '0';
                  const handler = (e) => {
                    if (e.propertyName !== 'max-height') return;
                    resetItemAndRemoveHandler(item, handler);
                    item.style.display = 'none';
                    if (index === itemsToHide.length - 1) {
                      animating = false;
                    }
                  };
                  item.addEventListener('transitionend', handler);
                });
              });
            }, index * 100);
          });
        }
      });
    }

    accordion.querySelectorAll('.item').forEach(item => {

      const header = item.querySelector('.header');
      const body = item.querySelector('.body');
      let isAnimating = false;

      header.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!isAnimating) {
            toggleAccordion(header, body);
          }
        }
      });

      header.addEventListener('click', () => {
        if (!isAnimating) {
          toggleAccordion(header, body);
        }
      });

      function toggleAccordion(header, body) {

        if (header.getAttribute('aria-expanded') === 'true') {
          // open => close
          isAnimating = true;
          header.setAttribute('aria-expanded', 'false');
          body.style.maxHeight = `${body.scrollHeight}px`;
          requestAnimationFrame(() => {
            body.style.maxHeight = '0';
            body.style.opacity = '0';
          });
          body.addEventListener('transitionend', () => {
            body.style.maxHeight = '';
            body.style.opacity = '';
            isAnimating = false;
            body.hidden = true;
          }, {once: true});
        } else {
          // close => open
          isAnimating = true;
          body.hidden = false;
          header.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = '0';
          body.style.opacity = '0';
          requestAnimationFrame(() => {
            body.style.maxHeight = `${body.scrollHeight}px`;
            body.style.opacity = '1';
          });
          body.addEventListener('transitionend', () => {
            body.style.maxHeight = '';
            body.style.opacity = '';
            isAnimating = false;
          }, {once: true});
        }
      }

    });

  });

});
